const ScheduledTournamentsCalendarApp = () => import(/* webpackChunkName: "ScheduledTournamentsCalendarApp" */ './containers/ScheduledTournamentsCalendarApp');
const ScheduledTournamentCalendar = () => import(/* webpackChunkName: "ScheduledTournamentCalendar" */ './components/ScheduledTournamentCalendar');

export const scheduledTournamentCalendarRouting = [
    {
        path: 'scheduled-tournament-calendar', name: 'scheduled-tournament-calendar', component: ScheduledTournamentsCalendarApp,
        children: [
            { path: '/', redirect: 'scheduled-tournament-calendar' },
            { path: 'scheduled-tournament-calendar', name: 'scheduled-tournament-calendar', component: ScheduledTournamentCalendar },
        ]
    }
]